// desktop.module.states.js

"use scrict";

import {
    bidIdResolver,
    bidResolver,
    bidNewResolver,
    dataResolver,
    docsResolver,
    bidDocsResolver
} from "./../../core/resolvers"


const desktopIndex = {
  name: 'desktop.index',
  url: "",
  component: "desktopindex",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./index/index.module")
      .then(mod => $ocLazyLoad.load(mod.DESKTOP_INDEX_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  }
};


const servicePriceIndex = {
    name: 'desktop.services-price',
    url: "services-price/",
    component: "servicesprice",
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./services-price/services-price.module")
        .then(mod => $ocLazyLoad.load(mod.SERVICE_PRICE_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }
};


const servicePaymentIndex = {
  name: 'desktop.services-payment',
  url: "services-payment/",
  component: "servicesPayment",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./services-payment/services-payment.module")
      .then(mod => $ocLazyLoad.load(mod.SERVICE_PAYMENT_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  }
};

const personalApplicationsIndex = {
  name: 'desktop.personal-applications-paged',
  url: "personal-applications-paged/",
  component: "personalApplications",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  }
};

const personalApplicationsPagedIndex = {
  name: 'desktop.personal-applications',
  url: "personal-applications/",
  component: "personalApplicationsPaged",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  }
};

const personalAppealsIndex = {
  name: 'desktop.personal-appeal',
  url: "personal-appeal/",
  component: "personalAppeal",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./personal-appeal/personal-appeal.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APPEAL_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  }
};

const sendAppealsIndex = {
  name: 'desktop.send-appeal',
  url: "send-appeal/",
  component: "sendAppeal",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./send-appeal/send-appeal.module")
      .then(mod => $ocLazyLoad.load(mod.SEND_APPEAL_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  }
};

const myApplicantsIndex = {
  name: 'desktop.my-applicants',
  url: "my-applicants/",
  component: "myApplicants",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/*webpackChunkName: "desktop.module" */ "./my-applicants/my-applicants.module")
      .then(mod => $ocLazyLoad.load(mod.MY_APPLICANTS_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  }
};

const bidViewIndex = {
    name: 'bidview',
    url: 'application/{bidId}/view/',
    component: 'bidview',
    text:  'Редактировать заявку',
    resolve: {
      bid: bidResolver
    },
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
        .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    },

};

const bidAnnulndex = {
  name: 'bidannul',
  url: 'application/{bidId}/annul/',
  component: 'bidannul',
  text:  'Аннулировать заявку',
  resolve: {
    bidId: bidIdResolver,
  },
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },

};

const bidAddFilesIndex = {
  name: 'bidaddfiles',
  url: 'application/{bidId}/add-files/',
  component: 'bidaddfiles',
  text:  'Отправить файлы',
  resolve: {
    bid: bidResolver
  },
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },

};




const bidClaimTuIndex = {
  name: 'bidclaimtu',
  url: 'application/{bidId}/claim-tu/',
  component: 'bidClaimTu',
  text:  'Редактировать заявку',
  resolve: {
    bidId:  bidIdResolver,
    docs:   docsResolver,
     bid: bidResolver
  },
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },

};

const bidProjectDocsIndex = {
  name: 'bidprojectdocs',
  url: 'application/{bidId}/project-docs/',
  component: 'bidProjectDocs',
  text:  'Редактировать заявку',
  resolve: {
    bidId:  bidIdResolver,
    data:   dataResolver
  },
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/* webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },

};

const bidIncomingDocsIndex = {
  name: 'biddocview',
  url: 'application/{bidId}/incoming-docs/',
  component: 'incomingDocs',
  text:  'Редактировать заявку',
  resolve: {
    bidId:  bidIdResolver,
    bid:    bidResolver,
    docsdata:   bidDocsResolver
  },
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

    return import(/*webpackChunkName: "desktop.module" */ "./personal-applications/personal-applications.module")
      .then(mod => $ocLazyLoad.load(mod.PERSONAL_APP_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },

};


const bidCloneService = {
    name: 'cloneservice',
    url: 'application/{bidId}/clone-service/',
    component: 'cloneService',
    text:  'Редактировать заявку',
    resolve: {
      bidId:  bidIdResolver,
      bid:    bidResolver,
      bidNew: bidNewResolver,
    },
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");

      return import(/*webpackChunkName: "desktop.module" */ "./clone-service/clone-service.module")
        .then(mod => $ocLazyLoad.load(mod.CLONEBID_APP_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    },

};




export { 
    desktopIndex,
    servicePriceIndex,
    servicePaymentIndex,
    personalApplicationsIndex,
    personalApplicationsPagedIndex,
    personalAppealsIndex,
    sendAppealsIndex,
    myApplicantsIndex,
    bidViewIndex,
    bidAnnulndex,
    bidClaimTuIndex,
    bidProjectDocsIndex,
    bidIncomingDocsIndex,
    bidAddFilesIndex,
    bidCloneService
};



// WEBPACK FOOTER //
// ./src/components/desktop/desktop.module.states.js